import { isEntitled } from "@/lib/subscription";

export const getFlags = () => {
  const q = new URLSearchParams(window.location.search);
  if (q.has("locked")) sessionStorage.setItem("axoris.flag.locked", q.get("locked") === "1" ? "1" : "0");
  const forcedLock = sessionStorage.getItem("axoris.flag.locked");
  return { aiPaused: q.get("ai") === "off", locked: forcedLock === null ? !isEntitled() : forcedLock === "1" };
};

const ORDER = { KNOWN: "K", ASSUMED: "A", UNKNOWN: "U" };

export function withRefs(items = []) {
  const seen = { K: 0, A: 0, U: 0 };
  return items
    .filter((i) => i.lifecycle !== "discarded")
    .map((i) => {
      const p = ORDER[i.epistemic];
      seen[p] += 1;
      return { ...i, ref: `${p}${seen[p]}` };
    });
}
